export enum MppBlockquoteTypes {
  HINT = 'hint',
  TIP = 'tip',
}
